import type { AppEntry } from '@/types/app';

/* F16: Sentence case Latin для всех трёх статусов.
   Кириллический uppercase в 12px («СКОРО») визуально тяжелее латинских
   аналогов; «Live/Beta/Soon» — короче и узнаваемее в IT-контексте. */
export const STATUS_LABEL: Record<AppEntry['status'], string> = {
  live: 'Live',
  beta: 'Beta',
  soon: 'Soon',
};
